export default "__VITE_ASSET__BbAX_d75__"